export default {
    title: 'Components/DDA Cards/Custom Card/Custom Card',
    tags: ['autodocs'],
    argTypes: {
      card_header_text: { control: 'text' },
      card_header_icon: { control: 'text' },
      card_header_icon_id: { control: 'text' },
      custom_class: {
        control: { type: 'text' },
        description: 'Custom class for the credit card component',
      },
      component_mode: {
        control: { type: 'check' },
        options: ['light-mode'],
        description: 'Mode of the credit card component',
      }
    },
    parameters: {
      docs: {
        description: {
          component: `
  To use the \`dda-custom-card\` component, pass the following props:
  
  \`\`\`html
<dda-custom-card
    card_header_text="Card Custom Title",
    card_header_icon="more_horiz",
    card_header_icon_id="cartHeaderAction"
    custom_class=""
    component_mode=""
></dda-custom-card>
    \`\`\`
  `,
        },
      },
    },  
  };
  
  const Template = (args) => {
    const attributes = Object.entries(args)
      .filter(([key, value]) => value !== undefined && key !== 'text')
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');
  
    return `<dda-custom-card ${attributes}></dda-custom-card>`;
  };
  
  export const Default = Template.bind({});
  Default.args = {
    card_header_text: 'Card Custom Title',
    card_header_icon: 'more_horiz',
    card_header_icon_id: 'cartHeaderdotts',
    custom_class: '',
    component_mode: '',
  };

